/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Eyebrow } from 'ui/atoms/Eyebrow/Eyebrow';

import styles from './ExampleSection.module.scss';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { ExampleSectionProps } from './ExampleSection.types';

export const ExampleSection = ({ topic, className }: ExampleSectionProps) => {
  const { t } = useInt();

  if (!topic.example?.trim()) {
    return null;
  }

  const paragraphs = topic.example.split('\n\n');
  const scenario = topic.illustrative_scenario?.trim();

  return (
    <SectionShell id="example" title={t('Worked example')} className={className}>
      {paragraphs.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}

      {scenario && (
        <div className={styles['scenario']}>
          <Eyebrow label={t('Illustrative scenario')} pill={false} className={styles['scenarioLabel']} />

          {scenario.split('\n\n').map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      )}
    </SectionShell>
  );
};
